"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CAL_PREFS_DATA = void 0;
const react_1 = __importDefault(require("react"));
const react_redux_1 = require("react-redux");
const mui_1 = require("tss-react/mui");
const DialogContent_1 = __importDefault(require("@mui/material/DialogContent"));
const FormControl_1 = __importDefault(require("@mui/material/FormControl"));
const FormGroup_1 = __importDefault(require("@mui/material/FormGroup"));
const Button_1 = __importDefault(require("@mui/material/Button"));
const Divider_1 = __importDefault(require("@mui/material/Divider"));
const Switch_1 = __importDefault(require("@mui/material/Switch"));
const core_1 = require("companion-app-components/utils/core");
const accountGroupsSelectors_1 = require("companion-app-components/flux/account-groups/accountGroupsSelectors");
const utils_1 = require("utils/utils");
const StdDialog_1 = __importDefault(require("components/Dialogs/StdDialog"));
const useQPreferences_1 = __importDefault(require("components/QPreferences/useQPreferences"));
const QAmountField_1 = __importDefault(require("components/QAmountField"));
const defaults_1 = require("data/preferences/defaults");
const styles_1 = require("../../styles");
const useStyles = (0, mui_1.makeStyles)()(styles_1.calendarPrefsStyles);
const isIe = require('is-iexplorer') || (0, utils_1.isOldEdge)(); // eslint-disable-line
const CAL_PREF_FIELDS = {
    showTxns: 'showTransactions',
    showSchTxns: 'showScheduleTransactions',
    exceedingAmount: 'exceedingAmount',
    showDailyBalances: 'showDailyBalances',
};
exports.CAL_PREFS_DATA = [
    {
        label: 'Show transactions',
        field: CAL_PREF_FIELDS.showTxns,
        id: 'cal-pref-show-txns',
    },
    {
        label: 'Show bill and income reminders',
        field: CAL_PREF_FIELDS.showSchTxns,
        id: 'cal-pref-show-schedule-txns',
    },
    {
        label: (labelProps) => {
            const { showAmountField, amount, onChange, classes } = labelProps;
            return (<div className={classes.exceedAmountRoot}>
          <span>Show only transactions greater than{showAmountField ? ':' : ''}</span>
          {showAmountField && (<div className={classes.exceedAmountField}>
              <QAmountField_1.default name="exceedingAmountField" id="cal-pref-exeeding-amount-field" editable value={amount} onSubmit={onChange} onBlur={onChange} showSign/>
            </div>)}
        </div>);
        },
        field: CAL_PREF_FIELDS.exceedingAmount,
        id: 'cal-pref-show-exceeding-amount',
    },
    {
        label: 'Show daily balances',
        field: CAL_PREF_FIELDS.showDailyBalances,
        id: 'cal-pref-show--daily-balances',
    },
];
const initialExceedingAmount = 100;
const CalPrefsModal = ({ onClose }) => {
    const { classes } = useStyles();
    const { datasetPreferences, setDatasetPreference } = (0, useQPreferences_1.default)();
    const isEntityShareEnableUser = (0, react_redux_1.useSelector)(accountGroupsSelectors_1.isEntityShareUser);
    const prefsHiddenForEntitySharedUser = [CAL_PREF_FIELDS.showSchTxns];
    const filteredCalPrefs = exports.CAL_PREFS_DATA.filter((calPref) => !isEntityShareEnableUser ? true : !prefsHiddenForEntitySharedUser.includes(calPref.field));
    const onCLose = () => {
        if (onClose)
            onClose();
    };
    function onExceedingAmountSave(event) {
        if (event && event.target) {
            const exceedingAmount = parseInt(event.target.value, 10);
            setDatasetPreference({ calendarTransaction: { exceedingAmount } });
            core_1.tracker.track(core_1.tracker.events.calendarPrefSave, {
                type: 'exceedingAmountValue',
                value: exceedingAmount,
            });
        }
    }
    function onHandleCheck(field) {
        return (event, checked) => {
            if (event && event.target) {
                let newValue;
                if (field !== CAL_PREF_FIELDS.exceedingAmount) {
                    newValue = checked;
                }
                else {
                    newValue = checked ? initialExceedingAmount : null;
                }
                setDatasetPreference({ calendarTransaction: { [field]: newValue } });
                core_1.tracker.track(core_1.tracker.events.calendarPrefSave, {
                    type: field,
                    value: newValue,
                });
            }
        };
    }
    const onResetDefaults = () => {
        setDatasetPreference({
            calendarTransaction: Object.assign(Object.assign({}, defaults_1.defaultDatasetPreferences.calendarTransaction), { accountsToShow: datasetPreferences.calendarTransaction.accountsToShow }),
        });
        core_1.tracker.track(core_1.tracker.events.calendarPrefResetDefault);
    };
    function renderFields() {
        const prefs = datasetPreferences.calendarTransaction;
        if (prefs) {
            const elements = filteredCalPrefs.map((pref) => {
                const fieldValue = pref.field !== CAL_PREF_FIELDS.exceedingAmount ? prefs[pref.field] : prefs[pref.field] !== null;
                return (<div className={classes.fieldRoot} key={`CalPrefsItem-${pref.field}`}>
            <div className={classes.fieldLabel}>
              {pref.field !== CAL_PREF_FIELDS.exceedingAmount ?
                        pref.label : (<pref.label showAmountField={fieldValue} amount={prefs[pref.field]} onChange={onExceedingAmountSave} classes={classes}/>)}
            </div>
            <Switch_1.default color="primary" checked={fieldValue} value={fieldValue ? 'on' : 'off'} onChange={onHandleCheck(pref.field)} id={pref.id}/>
          </div>);
            });
            return elements;
        }
        return null;
    }
    return (<StdDialog_1.default open classes={isIe ? { paper: classes.dialogPaper } : {}} onClose={onCLose} title="Calendar Preferences">
      <DialogContent_1.default>
        <FormControl_1.default component="fieldset">
          <FormGroup_1.default>
            {renderFields()}
          </FormGroup_1.default>
        </FormControl_1.default>
        <Divider_1.default />
      </DialogContent_1.default>
      <div className={classes.buttonArea}>
        <Button_1.default className={isEntityShareEnableUser ? classes.resetButtonHidden : undefined} color="primary" onClick={onResetDefaults} id="txn-pref-reset-to-defaults">
          Reset To Defaults
        </Button_1.default>
        <Button_1.default color="primary" onClick={onCLose} id="txn-pref-done">
          Done
        </Button_1.default>
      </div>

    </StdDialog_1.default>);
};
exports.default = react_1.default.memo(CalPrefsModal);
